import { render, staticRenderFns } from "./BaseHeading.vue?vue&type=template&id=6700a2ff&scoped=true&"
import script from "./BaseHeading.vue?vue&type=script&lang=js&"
export * from "./BaseHeading.vue?vue&type=script&lang=js&"
import style0 from "./BaseHeading.vue?vue&type=style&index=0&id=6700a2ff&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6700a2ff",
  null
  
)

export default component.exports